module.exports = __webpack_public_path__ + "images/notifications.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/notifications.jpg
 ** module id = 55
 ** module chunks = 1
 **/